$(document).ready(function() {
 
    //Custom Multiple Select
    $(".custom-multiple-select-area").select2({
        closeOnSelect : false,
        placeholder : "Filter by area",
        allowHtml: true,
        allowClear: true,
        tags: true // 
    });

    $(".custom-multiple-select-sector").select2({
        closeOnSelect : false,
        placeholder : "Filter by sector",
        allowHtml: true,
        allowClear: true,
        tags: true // 
    });

    $(".custom-multiple-select-type").select2({
        closeOnSelect : false,
        placeholder : "Filter by type",
        allowHtml: true,
        allowClear: true,
        tags: true // 
    });

    $(".custom-multiple-select-fs-type").select2({
        closeOnSelect : false,
        placeholder : "Filter",
        allowHtml: true,
        allowClear: true,
        tags: true // 
    });

    $('.btn-primary-small').click(function() {
        $(".custom-multiple-select-area").val(null).trigger("change");
        $(".custom-multiple-select-sector").val(null).trigger("change");
        $(".custom-multiple-select-type").val(null).trigger("change");
        $(".custom-multiple-select-fs-type").val(null).trigger("change");
      });

      $('.togglenav').click(function() {
        $(this).toggleClass('open');
        $('#MobileNavigation').toggleClass('open');
        $('body').toggleClass('mobile-enable');
      });

      mobileNavigation(); 
      $( window ).resize(function() {
     //   mobileNavigation();
      }); 

}); 

function mobileNavigation() { 
        $(".nav-main > ul > li > a").on('click',function() {
          if($(window).width() <= 1024) {
            var link = $(this);
            var closest_ul = link.closest("ul");
            var parallel_active_links = closest_ul.find(".active")
            var closest_li = link.closest("li");
            var link_status = closest_li.hasClass("active");
            var count = 0; 
    
            closest_ul.find("ul").slideUp(function() {
                    if (++count == closest_ul.find("ul").length)
                            parallel_active_links.removeClass("active");
            });
    
            if (!link_status) {
                    closest_li.children("ul").slideDown();
                    closest_li.addClass("active");
            }
          } else {
            $(".nav-main > ul > li").removeClass('active');
          }
        }) 
      
}


$(window).on("load", function() {
	$(".select2-search__field").attr("aria-label", "Filter By");
    // $("span, p, div, h3, h4").attr("role", "region");
    // $("span, p, div, h3, h4").attr("aria-label", "odtr");
    $('span.select2-selection').attr("role", "combobox");
});
